module.exports = __webpack_public_path__ + "img/tupu-img.1025b360.jpg";